import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    if (error.response?.status === 401 && !cfg._retry && url.startsWith("/admin")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export const fileUrl = (p) => (p ? `${API}/files/${p}` : "");

export function formatApiError(e) {
  const d = e?.response?.data?.detail;
  if (!e?.response) return "Impossibile contattare il server. Controlla la connessione e riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join(" · ") || "Dati non validi.";
  return "Si è verificato un errore. Riprova.";
}

export function imgSources(image, imageSm) {
  if (!image) return null;
  if (image.startsWith("/img/")) {
    return { src: `${image}-800.webp`, srcSet: `${image}-480.webp 480w, ${image}-800.webp 800w` };
  }
  return { src: fileUrl(image), srcSet: imageSm ? `${fileUrl(imageSm)} 640w, ${fileUrl(image)} 1600w` : undefined };
}

const eur = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });
export const formatPrice = (o) => (o.price != null ? eur.format(o.price) : o.price_note || "Su richiesta");
export const formatDate = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" }) : "");
